// extracted by mini-css-extract-plugin
export default {"richtext":"lsf-richtext","richtext__container":"lsf-richtext__container","richtext__orig-container":"lsf-richtext__orig-container","richtext__work-container":"lsf-richtext__work-container","richtext__iframe":"lsf-richtext__iframe","richtext__orig-iframe":"lsf-richtext__orig-iframe","richtext__work-iframe":"lsf-richtext__work-iframe","richtext__loading":"lsf-richtext__loading","richtext__line":"lsf-richtext__line","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630383403
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  